import { StateCreator } from "zustand";
import type { SkyViewStore } from "./index";

export interface SidebarSlice {
  isExpanded: boolean;
  toggleExpanded: () => void;
  setExpanded: (expanded: boolean) => void;
}

export const createSidebarSlice: StateCreator<
  SkyViewStore,
  [["zustand/persist", unknown], ["zustand/immer", never]],
  [],
  SidebarSlice
> = (set) => ({
  isExpanded: true,
  toggleExpanded: () =>
    set((state) => ({
      isExpanded: !state.isExpanded,
    })),
  setExpanded: (expanded: boolean) =>
    set(() => ({
      isExpanded: expanded,
    })),
});
